/**
 * 静态工具方法
 */

const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
export default {
    regExps: {
        mobile: /^[1][0-9]{10}$/,
        email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
        // 身份证
        idCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        // 军官证
        officer: /^[a-zA-Z0-9]{7,21}$/,
        // 护照
        passport: /^[a-zA-Z0-9]{3,21}$/,
        // 邮政编码
        zipcode: /^[1-9][0-9]{5}$/,
        // 固定电话
        phone: /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/,
        // 银行卡号 校验数字 空格
        bankCard: /^[\d\s]*$/,
        // hehe的电话号码校验
        uglyPhone: /^[，；、（）,;\(\)-/~\+\\\d\s]*$/,
        taxAmount: /^\d{1,12}(\.\d{0,2})?$/,
        //申报登录信息校验
        // IdNumber: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        // 简单校验够不够15或者18位
        IdNumber: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        taxPhone: /^((13[0-9])|(14[5,6,7,9])|(15[^4])|(16[5,6])|(17[0-9])|(18[0-9])|(19[1,8,9]))\d{8}$/,
    },
    regExpTest(source, regType) {
        return this.regExps[regType].test(source)
    },
    regExpTestEmail(source) {
        let result = true
        const arr = source.split(';')
        arr.forEach((item) => {
            if (!this.regExps.email.test(item)) result = false
        })
        return result
    },
    encode(input) {
        let output = ''
        let chr1
        let chr2
        let chr3
        let enc1
        let enc2
        let enc3
        let enc4
        let i = 0
        input = this.utf8Encode(input)
        while (i < input.length) {
            chr1 = input.charCodeAt(i++)
            chr2 = input.charCodeAt(i++)
            chr3 = input.charCodeAt(i++)
            enc1 = chr1 >> 2
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
            enc4 = chr3 & 63
            if (isNaN(chr2)) {
                enc3 = enc4 = 64
            } else if (isNaN(chr3)) {
                enc4 = 64
            }
            output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
        }
        return output
    },

    // public method for decoding
    decode(input) {
        let output = ''
        let chr1
        let chr2
        let chr3
        let enc1
        let enc2
        let enc3
        let enc4
        let i = 0
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
        while (i < input.length) {
            enc1 = keyStr.indexOf(input.charAt(i++))
            enc2 = keyStr.indexOf(input.charAt(i++))
            enc3 = keyStr.indexOf(input.charAt(i++))
            enc4 = keyStr.indexOf(input.charAt(i++))
            chr1 = (enc1 << 2) | (enc2 >> 4)
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
            chr3 = ((enc3 & 3) << 6) | enc4
            output += String.fromCharCode(chr1)
            if (enc3 !== 64) {
                output += String.fromCharCode(chr2)
            }
            if (enc4 !== 64) {
                output += String.fromCharCode(chr3)
            }
        }
        output = this.utf8Decode(output)
        return output
    },

    // private method for UTF-8 encoding
    utf8Encode(string) {
        string = string.replace(/\r\n/g, '\n')
        let utftext = ''
        for (let n = 0; n < string.length; n++) {
            const c = string.charCodeAt(n)
            if (c < 128) {
                utftext += String.fromCharCode(c)
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192)
                utftext += String.fromCharCode((c & 63) | 128)
            } else {
                utftext += String.fromCharCode((c >> 12) | 224)
                utftext += String.fromCharCode(((c >> 6) & 63) | 128)
                utftext += String.fromCharCode((c & 63) | 128)
            }
        }
        return utftext
    },

    // private method for UTF-8 decoding
    utf8Decode(utftext) {
        let string = ''
        let i = 0
        let c = 0
        const c1 = 0
        let c2 = 0
        let c3 = 0
        while (i < utftext.length) {
            c = utftext.charCodeAt(i)
            if (c < 128) {
                string += String.fromCharCode(c)
                i++
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1)
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
                i += 2
            } else {
                c2 = utftext.charCodeAt(i + 1)
                c3 = utftext.charCodeAt(i + 2)
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
                i += 3
            }
        }
        return string
    },

    /**
     * 分页
     * @param {*} list  数据列表
     * @param {*} pageSize  每页显示几条数据
     * @param {*} currentPage 当前页
     * 返回res包括分页后的数据列表resList，总过有多少数据num，上一页prePage
     *
     */
    paging(list, pageSize, currentPage) {
        if (!list || !pageSize || !currentPage) return
        const num = list.length
        const res = {
            resList: [],
            num, // 总共多少数据
            prePage: currentPage - 1, // 上一页
        }
        for (let i = 0; i < pageSize; i++) {
            if (list[(currentPage - 1) * pageSize + i]) res.resList.push(list[(currentPage - 1) * pageSize + i])
        }
        return res
    },
    /**
     * 查询方法
     * @param {*} data 需要过滤的数据
     * @param {*} arr 查询条件数组格式[{type:'',value:''},{type:'',value1:'',value2:''}]
     *  查询方法分两种 is传单个value 过滤结果为value的值
     * between传value1，value2 过滤结果为两个值之间的值
     * 返回结果为过滤之后的数据
     */
    searchData(data, arr) {
        if (!data || !arr) return
        for (const val of arr) {
            if (val.value) {
                data = isFilter(val, data)
            } else {
                data = betweenFilter(val, data)
            }
        }
        return data

        function isFilter(condition, data) {
            return data.filter((item) => {
                if (condition.value !== 0 && !condition) return data
                return item[condition.type] == condition.value
            })
        }

        function betweenFilter(condition, data) {
            return data.filter((item) => {
                if ((condition.value1 !== 0 && !condition.value1) || (condition.value2 !== 0 && !condition.value2) || (!item[condition.type] && item[condition.type] !== 0)) return data
                return (item[condition.type].replace('-', '').replace('-', '').slice(0, 8) > condition.value1 || item[condition.type].replace('-', '').replace('-', '').slice(0, 8) == condition.value1) && (item[condition.type].replace('-', '').replace('-', '').slice(0, 8) < condition.value2 || item[condition.type].replace('-', '').replace('-', '').slice(0, 8) == condition.value2)
            })
        }
    },

    /**
     * 解析xml
     * @param {Object} reg 需要匹配的正则对象
     * @param {String} str 需要匹配的xml报文
     * @return {Array} 返回结果为过滤之后的数据
     */
    analysisXml(reg = {}, str = '') {
        const result = {
            code: '',
            value: [],
        }
        Object.keys(reg).forEach((key) => {
            const item = str.match(reg[key])
            if (item && item.length) {
                if (/CODE/.test(item[0])) result.code = item[0].replace(/[<].*?[>]/g, '')
                else {
                    if (result.value.length !== item.length) {
                        for (let i = 0; i < item.length; i++) {
                            result.value.push({})
                        }
                    }
                    result.value.forEach((res, index) => {
                        res[key] = item[index].replace(/[<].*?[>]/g, '')
                    })
                }
            }
        })
        return result
    },

    loading(msg = '请求已发送...') {
        this.opening = window.layer.msg(msg, {
            time: 0,
            skin: 'layer-loading-self',
            icon: 16,
            shade: 0.5,
        })
    },
    loaded() {
        window.layer.close(this.opening)
    },
    // 计算中文/英文字符长度
    lengthForString(temp) {
        let len = 0
        temp = $.trim(temp)
        for (let i = 0; i < temp.length; i += 1) {
            const c = temp.charCodeAt(i)
            // 单字节加1
            if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                len += 1
            } else {
                len += 2
            }
        }
        return len
    },
    /**
     * 生成默认查询时间段
     * @param {number} months 查几个月 默认1个月
     */
    genPeriodByMonth(months = 1) {
        const now = new Date()
        const month = now.getMonth()
        const result = {}
        result.end = `${now.getFullYear()}-${month + 1}-${now.getDate()}`
        now.setMonth(month - months)
        result.start = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
        return result
    },
    /**
     * 两个日期之差
     */
    DateMinus(date1, date2) {
        // date1:小日期   date2:大日期
        const sdate = new Date(date1)
        const now = new Date(date2)
        const days = now.getTime() - sdate.getTime()
        const day = parseInt(days / (1000 * 60 * 60 * 24))
        return day
    },
    // 现在时间
    getNowDate() {
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        if (month == 0) {
            month = 12
            year = year - 1
        }
        if (month < 10) {
            month = '0' + month
        }
        return {
            nowDate: `${year}${month}${day}`,
            now_Date: `${year}-${month}-${day}`,
        }
    },
    // 当月第一天、最后一天
    getMonthFirstLast() {
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
        return {
            firstDate: `${year}-${month}-${firstDay.getDate()}`,
            lastDate: `${year}-${month}-${lastDay.getDate()}`,
            firstDate1: `${year}-${month > 9 ? month : '0' + month}-${'0' + firstDay.getDate()}`,
            lastDate1: `${year}-${month > 9 ? month : '0' + month}-${lastDay.getDate()}`,
        }
    },
    // 上月的第一天和最后一天
    getLastMonthFirstLast() {
        let nowDays = new Date()
        let year = nowDays.getFullYear()
        let month = nowDays.getMonth()
        if (month == 0) {
            month = 12
            year = year - 1
        }
        if (month < 10) {
            month = '0' + month
        }
        let firstDayOfPreMonth = year + '-' + month + '-' + '01'
        let preMonth = year + '-' + month
        let lastDay = new Date(year, month, 0)
        let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
        firstDayOfPreMonth = firstDayOfPreMonth.toString()
        lastDayOfPreMonth = lastDayOfPreMonth.toString()
        return {
            firstDayOfPreMonth,
            lastDayOfPreMonth,
            preMonth,
        }
    },
    //上一季度
    getQuarter() {
        let nowDays = new Date()
        let year = nowDays.getFullYear()
        let month = nowDays.getMonth() + 1
        switch (month) {
            case 1:
            case 2:
            case 3:
                return year - 1 + '-Q' + 4
                break
            case 4:
            case 5:
            case 6:
                return year + '-Q' + 1
                break
            case 7:
            case 8:
            case 9:
                return year + '-Q' + 2
                break
            case 10:
            case 11:
            case 12:
                return year + '-Q' + 3
                break
        }
    },
    post_downLoad(params, url, callback) {
        //params是post请求需要的参数，url是请求url地址
        var form = document.createElement('form')
        form.style.display = 'none'
        form.action = url
        form.method = 'post'
        form.enctype = ''
        document.body.appendChild(form)
        // 动态创建input并给value赋值
        for (var key in params) {
            var input = document.createElement('input')
            input.type = 'hidden'
            input.name = key
            input.value = params[key]

            form.appendChild(input)
        }
        form.submit()
        form.remove()
        callback && callback()
    },
    post_downLoadEncode(params, url, callback) {
        //params是post请求需要的参数，url是请求url地址
        var form = document.createElement('form')
        form.style.display = 'none'
        form.action = url
        form.method = 'post'
        document.body.appendChild(form)
        // 遍历对象的键值对
        console.log(params)
        for (const key in params) {
            const value = params[key]

            // 如果值是一个对象数组
            if ((Array.isArray(value) && value.every((item) => typeof item === 'object')) || typeof value === 'object') {
                // 将对象数组转换为字符串

                const arrayString = JSON.stringify(value)

                // 创建输入字段
                const input = document.createElement('input')
                input.type = 'hidden'
                input.name = key
                input.value = arrayString
                form.appendChild(input)
            } else {
                // 如果值不是对象数组，直接创建输入字段
                const input = document.createElement('input')
                input.type = 'hidden'
                input.name = key
                input.value = value
                form.appendChild(input)
            }
        }
        // 遍历对象的键值对
        form.submit()
        form.remove()
        callback && callback()
    },
    post_downLoadExcel(params, url, callback) {
        const req = new XMLHttpRequest()
        req.open('POST', url, true)
        req.responseType = 'blob'
        req.setRequestHeader('Content-Type', 'application/json')
        req.setRequestHeader('accessToken', localStorage.getItem('id_token'))
        req.onload = function () {
            const data = req.response
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            //处理名称
            const responseFileName = req.getResponseHeader('Content-Disposition').split('=')[1].replace(/["|"]/g, '')
            const resetFileName = decodeURIComponent(responseFileName)
            const blobUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.download = resetFileName
            a.href = blobUrl
            a.click()
            URL.revokeObjectURL(blobUrl) // 释放内存
        }
        req.send(params ? JSON.stringify(params) : '')
        callback && callback()
    },
    /**
   * 文件 导出
   * url 接口
   * fileType 各个表的type
   * 已开具发票采集   sb_summary
    认证相符的增值税专用发票  sb_transportation
    企业所得税申报表查询 enterprise_result
    申报任务跟踪(企业所得税)  enterprise_task
    申报生成(企业所得税)  enterprise_declare
    个税申报结果表（综合所得申报）导出  gs_result
    个税申报任务追踪导出  gs_task
    申报任务跟踪(小规模)导出  small_tracking
    申报表生成(小规模)导出  small_declaration
    申报任务跟踪(一般)导出  gl_tracking
    申报表生成(一般)导出  gl_querygen
    申报任务跟踪(印花税)导出stamp_dutytask
    印花税申报结果查询导出 stampduty_result 
   * fileName 自定义文件名 false则设置为返回的response文件名
   * method 请求方式
   * response_type 数据格式
   * params post参数
   * blob_type 对象所包含数据的 MIME 类型。如果类型false，则该值为空字符串。
   */
    file_download(url, params, fileType, method, response_type, fileName, blob_type) {
        const req = new XMLHttpRequest()
        req.open(method, url, true)
        req.responseType = response_type
        req.setRequestHeader('Content-Type', 'application/json')
        req.setRequestHeader('accessToken', localStorage.getItem('id_token'))
        req.onload = function () {
            const data = req.response
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const blobUrl = window.URL.createObjectURL(blob)
            //处理名称
            const responseFileName = req.getResponseHeader('Content-Disposition').split('=')[1].replace(/["|"]/g, '')
            const resetFileName = decodeURIComponent(responseFileName)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.download = fileName ? fileName + '.xlsx' : resetFileName
            a.href = blobUrl
            a.click()
            URL.revokeObjectURL(blobUrl) // 释放内存
        }
        params.type = fileType || ''
        req.send(params ? JSON.stringify(params) : '')
    },
    /**
     * 申报文件下载
     * url 接口
     * fileName 自定义文件名 false则设置为返回的response文件名
     * method 请求方式
     * response_type 数据格式
     * params post参数
     * blob_type 对象所包含数据的 MIME 类型。如果类型false，则该值为空字符串。
     */
    declarefile_download(url, fileName, method, response_type, params, blob_type) {
        const req = new XMLHttpRequest()
        req.open(method, url, true)
        req.responseType = response_type
        req.setRequestHeader('Content-Type', 'application/json')
        req.setRequestHeader('accessToken', localStorage.getItem('id_token'))
        req.onload = function () {
            const data = req.response
            const blob1 = new Blob([data], {
                type: 'application/zip; application/octet-stream;',
            })
            const blob2 = new Blob([data])
            const blob = blob_type ? blob1 : blob2
            //处理名称
            const responseFileName = req.getResponseHeader('Content-Disposition').split('=')[1].replace(/["|"]/g, '')
            const resetFileName = decodeURIComponent(responseFileName)
            const blobUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.download = fileName ? fileName : resetFileName
            a.href = blobUrl
            a.click()
            URL.revokeObjectURL(blobUrl) // 释放内存
        }
        req.send(params ? JSON.stringify(params) : '')
    },
    org_export(url, param) {
        const req = new XMLHttpRequest()
        req.open('POST', url, true)
        req.responseType = 'arraybuffer'
        req.setRequestHeader('Content-Type', 'application/json')
        req.onload = function () {
            const data = req.response
            const blob = new Blob([data])
            const fileName = req.getResponseHeader('Content-Disposition').split('=')[1].replace(/["|"]/g, '') //处理名称
            const resetFileName = decodeURIComponent(fileName)
            const blobUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.download = resetFileName
            a.href = blobUrl
            a.click()
            document.body.removeChild(a)
        }
        req.send(JSON.stringify(param))
    },
    getBlueInvoiceFromRemark({ remarks = '', invoiceCodeLabel = '对应蓝字专用发票代码', invoiceNumberLabel = '号码' } = {}) {
        const remark = remarks.replace(/\s/g, '')
        if (!remark) {
            return {
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
            }
        }
        const codeStartIndex = remark.indexOf(invoiceCodeLabel) + invoiceCodeLabel.length + 1
        const codeEndIndex = remark.indexOf(invoiceNumberLabel)
        const numberStartIndex = codeEndIndex + invoiceNumberLabel.length + 1
        const numberEndIndex = numberStartIndex + 8
        const blueInvoiceCode = remark.substring(codeStartIndex, codeEndIndex)
        const blueInvoiceNumber = remark.substring(numberStartIndex, numberEndIndex)
        return {
            blueInvoiceCode,
            blueInvoiceNumber,
        }
    },
    // 根据税收合并编码判断是否是成品油
    isRefinedOil(code) {
        const ALL_CODE = ['1070101010100000000', '1070101010200000000', '1070101010300000000', '1070101010400000000', '1070101010500000000', '1070101020100000000', '1070101020200000000', '1070101030100000000', '1070101030200000000', '1070101030300000000', '1070101030400000000', '1070101040100000000', '1070101040200000000', '1070101040300000000', '1070101050100000000', '1070101050200000000', '1070101050300000000', '1070101060100000000', '1070101070100000000', '1070101070200000000', '1070101070300000000']
        return ALL_CODE.indexOf(code) !== -1
    },
    // 根据发票代码判断发票种类
    //     12位发票代码（最后两位）：
    //     11：电子发票 51
    //     04、05：普通发票
    //     06、07：卷式发票 41
    //     12：通行费电子发票 14
    //     17：二手车销售统一发票 15
    // 12位发票（第八位）：
    //      2：机动车发票 12
    // 10位发票（第八位）：
    //    1/5：专用发票 0
    //    3/6：普通发票 2
    //    2/7：货运发票
    getCodeToType(code) {
        if (!code) return
        let invType = null
        if (code.length == 10) {
            const codeWord = code[7]
            if (codeWord == '1' || codeWord == '5') {
                invType = '0'
            } else if (codeWord == '3' || codeWord == '6') {
                invType = '2'
            }
        } else if (code.length == 12) {
            const codeWord = code[10] + code[11]
            if (codeWord == '04' || codeWord == '05') {
                invType = '2'
            } else if (codeWord == '06' || codeWord == '07') {
                invType = '41'
            } else if (codeWord == '11') {
                invType = '51'
            } else if (code[7] == '2') {
                invType = '12'
            }
        }
        return invType
    },
}



// WEBPACK FOOTER //
// ./src/common/utils.js